/**
 * 元数据：省市产品类型等.
 */
import apis from '../apis'
import * as types from '../mutation-types'

const state = {
    provinces: [],
    apts:[],
    cities: [],
    pid: '',
    productTypes:[],//产品与服务类型
    companyTypes:[],//公司类型
    taxpayerTypes:['一般纳税人','小规模纳税人'],
    enterpriseTypes:['国有企业','民营企业','股份有限公司','外资企业','合资企业','其他'],//企业性质
    contactTypes:['业务对接人','上级负责人','专业负责人','技术负责人','工程负责人'],
    auditStatus:['注册审核','已认证', '未认证', '认证未过'],
    adjustStatus: ['待审批', '审批中', '通过', '不通过', '', '', '自动审核']
}
const getters = {
    provinces: state => state.provinces,
    apts: state => state.apts,
    cities: state => state.cities,
    contactTypes: state => state.contactTypes,
    productTypes: state => state.productTypes,
    companyTypes: state => state.companyTypes,
    taxpayerTypes: state => state.taxpayerTypes,
    enterpriseTypes: state => state.enterpriseTypes,
    auditStatus: state => state.auditStatus,
    adjustStatus: state => state.adjustStatus
}

const actions = {
    getProvinces({ commit, state }){
        return apis.getProvinces(state.provinces, provinces => {
            commit(types.FETCH_PROVINCES, provinces)
        }, err => {
            this.$alert(err)
        })
    },
    getApt({ commit, state }){
        return apis.getApt(state.apts, apts => {
            commit(types.FETCH_APTS, processOptions(apts))
        }, err => {
            this.$alert(err)
        })
    },
    getCities({ commit, state }){
        return apis.getCities(state.pid, cities => {
            commit(types.FETCH_CITIES, cities)
        }, err => {
            this.$alert(err)
        })
    },
    getProductTypes({ commit, state }){
        return apis.getProductTypes(state, productTypes => {
            commit(types.FETCH_PRODUCT_TYPES, processOptions(productTypes))
        }, err => {
            this.$alert(err)
        })
    },
    getCompanyTypes({ commit, state }){
        return apis.getCompanyTypes(state, companyTypes => {
            commit(types.FETCH_COMPANY_TYPES, processOptions(companyTypes))
        }, err => {
            this.$alert(err)
        })
    }
}

const mutations = {
    [types.FETCH_COMPANY_TYPES] (state,  payload ) {
        state.companyTypes = payload
    },
    [types.FETCH_PRODUCT_TYPES] (state,  payload ) {
        state.productTypes = payload
    },
    [types.FETCH_PROVINCES] (state,  payload ) {
        state.provinces = payload
    },
    [types.FETCH_APTS] (state,  payload ) {
        state.apts = payload
    },
    [types.FETCH_CITIES] (state,  payload ) {
        state.cities = payload
    },
    [types.SELECT_PROVINCE] (state,  payload ) {
        state.pid = payload
    }
}
function processOptions(types){
    if(types.length){
        types.forEach(t=>{
            t.value = t.id;
            t.label = t.text;
            if(t.children && t.children.length){
                processOptions(t.children)
            }else{
                delete t.children
            }
        })
    }
    return types
}
export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/meta.js